/* eslint-disable react/no-did-update-set-state */

import React, { Children, Component } from 'react'
import classNames from 'classnames/bind'
import styles from './styles.module.scss'

const cx = classNames.bind(styles)

const pointerStyle = (width, left) => ({
  width: `${width}px`,
  transform: `translate3d(${left}px, -2px, 0)`,
})

export const Tab = ({ name, children }) => (
  <div data-tab-name={name} className={styles.tab}>
    {children}
  </div>
)

export class TabGroup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTabName: props.default || null,
      pointer: {
        width: 40,
        offset: 0,
      },
    }
  }

  componentDidMount() {
    this.calculatePointerPosition()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.default !== this.props.default) {
      this.setState(
        {
          activeTabName: this.props.default || null,
        },
        () => {
          this.calculatePointerPosition()
        }
      )
    }
  }

  calculatePointerPosition = () => {
    const { _activeButton = null } = this

    if (_activeButton) {
      const rect = _activeButton.getBoundingClientRect()
      const width = Math.round(rect.width)
      const offset = _activeButton.offsetLeft

      this.setState({
        pointer: { width, offset },
      })
    }
  }

  handleButtonClick = (activeTabName) => (event) => {
    const { props, state } = this
    const prevTabName = state.activeTabName

    if (prevTabName !== activeTabName) {
      this.setState({ activeTabName })

      if (props.onTabChange) {
        props.onTabChange({ prevTabName, activeTabName, srcEvent: event })
      }

      setTimeout(this.calculatePointerPosition)
    }
  }

  render() {
    const children = Children.toArray(this.props.children)
    const { activeTabName, pointer } = this.state

    if (children.length === 0) {
      return null
    }

    const buttons = children.map((child) => {
      const { name, title, disabled = false } = child.props
      const active = child.props.name === activeTabName

      const classname = cx('headerButton', {
        active,
        disabled,
      })

      return (
        <div
          key={child.props.name}
          role="button"
          tabIndex="0"
          className={classname}
          ref={(input) => {
            if (active) {
              this._activeButton = input
            }
          }}
          onClick={this.handleButtonClick(name)}
        >
          {title}
        </div>
      )
    })

    const content = activeTabName
      ? children.find((child) => child.props.name === activeTabName)
      : null

    const style = pointerStyle(pointer.width, pointer.offset)

    return (
      <div className={styles.tabGroup}>
        <div className={styles.header}>
          <div className={styles.headerButtons}>{buttons}</div>
          <div className={styles.pointer} style={style} />
        </div>
        <div className={styles.content}>{content}</div>
      </div>
    )
  }
}
